module.exports = __webpack_public_path__ + "img/4.03280c92.jpg";